import { z } from 'zod';
// ── Admin: editing plans ────────────────────────────────────────────────────
export const planTranslationSchema = z.object({
    locale: z.string().min(2).max(8),
    name: z.string().trim().min(1, 'A plan needs a name').max(80),
    tagline: z.string().trim().max(200).nullable().optional(),
    features: z.array(z.string().trim().min(1).max(200)).max(20).optional(),
});
export const upsertPlanSchema = z.object({
    slug: z
        .string()
        .trim()
        .min(1)
        .max(40)
        .regex(/^[a-z0-9-]+$/, 'Use lowercase letters, numbers and hyphens'),
    /** Decimal string, never a number: JSON numbers cannot hold money exactly. */
    monthlyPrice: z
        .string()
        .trim()
        .regex(/^\d+(\.\d{1,4})?$/, 'Enter an amount like 29 or 29.00'),
    currencyCode: z.string().length(3),
    isPublished: z.boolean().optional(),
    isPopular: z.boolean().optional(),
    position: z.number().int().min(0).max(999).optional(),
    /** At least the default language, so a plan is never nameless. */
    translations: z.array(planTranslationSchema).min(1),
});
// ── Admin: editing site copy ────────────────────────────────────────────────
export const updateSiteContentSchema = z.object({
    locale: z.string().min(2).max(8),
    /**
     * Only the keys being changed. An empty string CLEARS the override and
     * restores the built-in default, which is how staff undo an edit without
     * needing to remember the original wording.
     */
    values: z.record(z.string().max(4000)),
});
// ── Partner self-registration ───────────────────────────────────────────────
export const partnerSignupSchema = z.object({
    accountName: z.string().trim().min(1, 'Tell us who you are').max(120),
    email: z.string().trim().toLowerCase().email('Enter a valid email address'),
    password: z.string().min(12, 'Use at least 12 characters').max(200),
    firstName: z.string().trim().max(80).optional(),
    lastName: z.string().trim().max(80).optional(),
    website: z.string().trim().url('Enter a full URL, including https://').max(200).optional(),
});
//# sourceMappingURL=site.js.map